import FindGamesBanner from "public/images/devils/devils_banner.jpg";
import SeatMap3dPreview from "public/images/devils/devils_flex_3d_venue.png";
import { howItWorks, faqs, NoInventoryModalDescription } from "./helpers";
import { routes } from "@/global/routes";
import { vendorUUIDs } from "../../constants";
import { TeamConfig } from "@/global/hooks/useTeamConfig";
import {
  DefaultCheckoutTerms,
  DefaultRegistrationTerms,
} from "../../default_terms_and_conditions";

// image sizes
// featured game card image : 350x180
// title: "Choose Your Games",

const backgroundImage =
  "https://ss-leagues.s3.amazonaws.com/NHL/devils/devils-background.jpeg";

const config: TeamConfig = {
  teamSchema: "devils_flex",
  browserTitle: "New Jersey Devils",
  packages: false,
  defaultRoute: routes.purchaseSeats,
  phoneNumber: "",
  teamName: "New Jersey Devils",

  // seat map configs
  seatMapConfigs: {
    venueId: "nam-us-10215-devils-sec",
    mapId: "main",

    sectionNameMapping: {
      "1": ["1", "PL1"],
      "2": ["2", "PL2"],
      "3": ["3", "PL3"],
      "4": ["4", "PL4"],
      "5": ["5", "PL5"],
      "6": ["6", "PL6"],
      "7": ["7", "C7", "PL7"],
      "8": ["8", "C8", "PL8"],
      "9": ["9", "C9", "PL9"],
      "10": ["10", "PL10"],
      "11": ["11", "PL11", "RST6"],
      "12": ["12", "PL12", "RST5"],
      "13": ["13", "PL13", "RST4"],
      "14": ["14", "PL14", "RST3"],
      "15": ["15", "PL15", "RST2"],
      "16": ["16", "RST1"],
      "17": ["17", "PL17"],
      "18": ["18", "C18", "PL18"],
      "19": ["19", "C19", "PL19"],
      "20": ["20", "C20", "PL20"],
      "21": ["21", "PL21"],
    },
  },

  // gift cards
  giftCardConfigs: {
    isMenuGiftCardEnabled: false,
    isLandingPageGiftCardEnabled: false,
    isStandalonePageGiftCardEnabled: false,
    redirectGiftCardUrl: routes.purchaseSeats,
  },

  // disabled routes
  disabledRoutes: [routes.giftCard],

  // switches
  checkoutCreditPackages: false,
  availableCreditEnabled: true,
  isCrowdHandlerEnabled: true,
  inventoryType: "SEAT-LEVEL",

  // purchase seats config
  purchaseSeatConfigs: {
    minGameSelectionCount: 1,
    minSeatLimit: 1,
    isSimilarSeatForAllEvents: false,
    allowManualCartInSimilar: false,
    isCheckoutEditSeatsEnabled: false,
    isDiffSeatAlertEnabled: false,
    checkoutTimerEnabled: false,
    showFrontendTotalAmount: false,
    showFrontendServiceFee: false,

    hideViewTicketsInThankYouPage: false,
  },

  // feature configs
  packageConfigs: {
    isPackageEnabled: false,
    canRemovePackageGames: false,
    staticBuildYourOwn: null,
  },

  // purchase credit configs
  purchaseCreditConfigs: {
    isLandingPurchaseCreditEnabled: false,
    isStandAlonePurchaseCreditEnabled: false,
    showPurchaseCreditLinkInHomeMenu: false,
    isPurchaseCreditHistoryEnabled: false,
    checkoutTimerEnabled: false,
  },

  // intercom settings
  intercomConfigs: {
    isIntercomEnabled: true,
    allowedPages: [],
  },

  // checkout validations
  checkoutValidation: {
    allowedZipFailCount: Infinity,
    allowedPaymentFailCount: Infinity,
  },
  isSaveCardAllowed: true,

  // analytics configs
  analyticsConfigs: {
    googleAnalyticsId: "",
    attrkPixelId: "",
    beaconId: "",
  },

  // call refresh inventory when selecting games
  refreshInventoryWhenEventClick: false,

  // redirect configs
  redirectConfigs: {
    internalRedirectUrl:
      "https://flex.attendevents.com/newjerseydevils_flex/events_home",
    externalRedirectUrl: "",
  },

  // urls
  accountManagerUrl: "https://am.ticketmaster.com/devils/",

  // vendor
  platform: vendorUUIDs.ticketmaster,

  // okta config
  oktaIssuer: "",
  oktaClientId: "",

  // images
  images: {
    findGamesBannerImage: FindGamesBanner.src,
    authBackgroundImage: backgroundImage,
    checkoutStatusPageImage: backgroundImage,
    logoImage:
      "https://ss-leagues.s3.amazonaws.com/NHL/NewJerseyDevils-aug21.png?width=64&height=64",
    logoNameImage: "",
    faviconImage:
      "https://ss-leagues.s3.amazonaws.com/NHL/NewJerseyDevils-aug21.png",
    seatMap3dPreviewImage: SeatMap3dPreview.src,
  },

  uiConfigs: {
    bannerImage: {
      title: "Choose Your Games",
      isBackgroundBasedBanner: true,
    },

    featuredGameCard: {
      showLogoWithTitle: false,
      hideOverlayLogo: false,
    },
    bottomBar: {
      showGameSelectionProgress: true,
    },

    progressBar: {
      staticProgressBarText: true,
    },
  },

  colors: {
    primary: "#CE1126",
  },

  howItWorks,
  faqs,

  languages: {
    topNavMenuItems: "",
    checkoutTermsAndCondition: <DefaultCheckoutTerms />,
    registrationTermsAndCondition: <DefaultRegistrationTerms />,
    purchaseSeats: {
      progressBarText: "Add one or more games to continue!",
      progressBarSuccessText:
        "You're good to go! Add more games or select Continue to view seating.",
    },
    purchaseGiftCard: null,
    redeemGiftCard: null,

    checkoutSuccessMessage: "Your purchase is complete!",
    checkoutSuccessDescription:
      "Thank you for your New Jersey Devils purchase!",

    noInventoryAlertModal: {
      description: {
        inventoryApiTriggered: <NoInventoryModalDescription />,
      },
    },
    giftCard: {
      title: "",
      createGiftCard: {
        description: "",
        recipient: {
          sendNowFalse: {
            description: "",
          },
          sendNowTrue: {
            description: "",
          },
        },
      },
      redeemGiftCard: {
        loggedIn: {
          description: "",
        },
        logout: {
          description: "",
        },
        success: {
          description: "",
        },
      },
    },
    signInAuthText:
      "Connect your Ticketmaster account to continue with seamless access.",
  },
};

export default config;
